module.exports = __webpack_public_path__ + "img/54600.2f3864af.jpg";